import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "../../config";

const CancelToken = axios.CancelToken;
var lastERequest = CancelToken.source();

export default class ForgotPasswordService {
    static forgotPassword = (email) => {
        return new Promise((resolve, reject) => {
            // TODO: Adjust server to parse "username" parameter as "email".
            axios
                .post(API_URL + 'forgotPassword', {
                    "username": email
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };

    static emailExists = email => {
        lastERequest.cancel();
        let newERequest = CancelToken.source();
        lastERequest = newERequest;
        return new Promise((resolve, reject) => {
            axios
                .get(API_URL + `emails/${encodeURIComponent(email)}`, {
                    cancelToken: newERequest.token
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
}
